<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body"
    :class="{'is-hidden-header' : targetScrollFlg}"
  >
  <BackgroundImage />
  <DocumentLink />

  <PCPrint />

    <!-- menu:start -->
    <PCMenu
      class="visible"
      v-if="visibleMenu"
      @closeMenu="visibleMenu = false"
    />
    <!-- menu:end -->

    <!-- ノートの選択（新規ノートを作成して保存する ＆ 保存先のノートを選ぶ） -->
    <transition name="popup">
      <PCNoteSelect
        v-if="state.visibleNoteSelect"
        :type="'knowledge'"
        :pageId="knowledgeId"
        :title="detail.title"
        @closeSelectNote="state.visibleNoteSelect = false"
      />
    </transition>

    <div id="wrapper">
      <!-- header:start -->
      <header id="header" class="header">
        <PCButtonHistoryBack />
        <div class="header-search-title">最新ナレッジ</div>
        <div class="header-label ga-knowledge-bookmark" role="button"
          @click="clickBookmark"
          :class="{'is-active':detail.bookmarks_id}"
        >
          <FontawesomeIcon v-if="detail.bookmarks_id" :icon="['fa','bookmark']" size="lg" class="ga-knowledge-bookmark" />
          <FontawesomeIcon v-else :icon="['far','bookmark']" size="lg" class="ga-knowledge-bookmark" />
        </div>
      </header>
      <!-- header:end -->

      <!-- menu-bar:start -->
      <!-- open -->
      <div class="menu-bar" role="button"
        :class="{'is-open' : !targetScrollFlg}"
        @click="visibleMenu = !visibleMenu"
      >
        <IconMenu class="icn"
          v-if="!targetScrollFlg"
        />
        <FontawesomeIcon :icon="['far','chevron-up']" size="lg" class="icn"
          v-if="targetScrollFlg"
        />
      </div>
      <!-- close -->
      <!-- menu-bar:end -->

      <!-- content:start -->
      <div id="content">
        <main class="" id="main">
          <div v-if="state.initLoading" class="box02 white">
            <div class="box02-hdg">
            </div>
            <div class="box02-body" id="scroll-target"
              style="height:calc(100vh - 108px);">
              <FontawesomeIcon :icon="['fal','spinner-third']" size="2x" class="mt40 mb200 icn fa-spin" />
            </div>
          </div>
          <div v-else class="box02 white">
            <div class="box02-hdg">
              <div class="navi-func-icon">
                <span role="button" class="icon"
                  @click="state.visibleNoteSelect = true"
                >
                  <span class="tip">ノートに保存</span>
                  <IcnNote class="icn svg-inline--fa" />
                </span>
                <span role="button" class="icon ga-print"
                  @click="printTarget('main')"
                >
                  <span class="tip">印刷</span>
                  <FontawesomeIcon :icon="['far','print']" class="icn ga-print" />
                </span>
              </div>
              <span class="txt-sup fs16">{{formatDate(detail.created)}}</span>
              <span v-if="detail.medium_name" class="txt-sup fs16">{{detail.medium_name}}</span>
            </div>
            <div class="box02-body" id="scroll-target"
              style="height:calc(100vh - 108px);"
              @scroll="handleScroll"
              >

              <div class="information-detail-inner" 
                :id="(detail.knowledge_type === 1) ? 'tamaster-content' : 'cms-content-area'">
                <p class="txt txt-blue mb32"><router-link to="/pc/knowledge-list">最新ナレッジ一覧へ</router-link></p>
                <p v-if="detail.medium_category_name" class="txt-sup">{{detail.medium_category_name}}</p>
                <p v-if="detail.classification" class="txt-sup">{{detail.classification}}</p>
                <h2 class="hdg03">{{detail.title}}</h2>

                <!-- knowledge_type=1以外は、subtitleには著者名が登録されている -->
                <div v-if="detail.knowledge_type !== 1 && detail.subtitle" 
                  id="author" class="author" :class="state.authorClass"
                  v-html="layoutSubtitle(detail.subtitle)"></div>
                <div v-html="detail.detail" @click="clickKnowledgeDetail($event)"></div>
                <div v-if="detail.knowledge_type === 4">
                  <!-- BUSINESS LAWYERS フッタ -->
                  <div id="business-lawyers-output-footer-html" class="box-gray box-gray business-lawyers-footer">
                    <!-- <p class="txt">
                      <span class="txt-accent"><strong>坂本　佳織</strong>　弁護士　</span>
                      アンダーソン・毛利ああああああああああああああああああああああああああああ
                    </p>
                    <p class="txt">アンダーソン・毛利ああああああああああああああああああああああああああああ</p>
                    <div class="box-logo">
                      <p class="txt">本記事は、<span class="txt-accent"><strong>BUSINESS LAWYERSの記事</strong></span>を転載して掲載しています。</p>
                      <figure><img src="/lc/app/images/logo-business-lawyers.png" alt=""></figure>
                      <p class="txt-note">※BUSINESS LAWYERSは企業法務に関わる方のために実務に役立つ企業法務ポータルサイトです。</p>
                    </div> -->
                  </div>
                </div>

              </div>
            </div>
          </div>
        </main>
      </div>
      <!-- content:end -->

      <span id="btnTop" @click="scrollAreaTop('#scroll-target')">TOP</span>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import { KnowledgeDetail } from '@/logic/knowledge/KnowledgeDetail'
import PCPrint from '@/components/pc/partial/PCPrint.vue'
import PCNoteSelect from '@/components/pc/popup/PCNoteSelect.vue'
import PCMenu from '@/components/pc/popup/PCMenu.vue'

export default defineComponent({
  components: {
    PCPrint,
    PCNoteSelect,
    PCMenu
  },
  props: {
    knowledgeId: {
      type: Number,
      default: null
    }
  },
  setup (props, context) {
    return { ...KnowledgeDetail(props, context) }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.dispatch('knowledge/setReferrerObject', from)
    })
  }
})
</script>

<style lang="scss" scoped>
#main {
  width: 100%;
  margin-left: 0;
}
.box02 {
  &-hdg {
    display: block;
    position: relative;
    &-icon {
      position: absolute;
      right: 40px;
      top: 50%;
      transform: translate3d(0,-50%,0);
      display: flex;
      .button {
        margin-left: 24px;
        font-size: 1.8rem;
        color: #005bac;
        @include hoverOpacity;
      }
    }
    .txt-sup {
      display: inline-block;
      margin: 0 20px 0 0;
      &.fs16{
        font-size : 1.6rem;
      }
    }
  }
  &-body {
    overflow: auto;
    padding: 0 40px 80px;
    .information-detail-inner {
      max-width: 780px;
      width: 100%;
      margin: 0 auto;
      padding: 40px 0;
    }

    .txt + .hdg03 {
      margin-top: 80px;
    }
    .txt + .hdg05 {
      margin-top: 50px;
    }
  }
}
@media print{
  .box02 {
    &-body {
      overflow: visible;
      height: auto !important;
    }
  }
}

#tamaster-content ::v-deep {
  font-size: 1.6rem;
  margin-top: 28px;
  color: $color-content;
  line-height: 2;
  .hdg03 {
    margin-bottom: 16px;
  }
  a {
    color: $color-link;
    font-size: 1.6rem;
    font-weight: normal;
  }
  strong {
    display: inline;
    font-size: 1.6rem;
    color: $color-hdg;
  }
  img {
    display: block;
    margin: 10px auto;
    max-width: 100%;
  }
  table {
    margin: 10px auto;
  }
}

#cms-content-area ::v-deep {
  font-size: 1.6rem;
  padding: 40px 0;
  //padding: 0px 60px 40px 40px;
  h2 {
    color: #3b4557;
    font-weight: 700;
    margin: 56px 0 32px;
    font-size: 2.4rem;
  }
  h3 {
    color: #3b4557;
    font-weight: 700;
    margin: 32px 0 24px;
    font-size: 2rem;
  }
  h4 {
    color: #3b4557;
    font-weight: 700;
    margin: 24px 0 24px;
    font-size: 1.8rem;
  }
  h5 {
    color: #3b4557;
    font-weight: 700;
    margin: 24px 0 24px;
    font-size: 1.6rem;
  }
  p {
    margin: 24px 0 24px;
    font-size: 1.6rem;
    color: #555;
    line-height: 2;
    &-sup {
      margin: 24px 0 24px;
      font-size: 1.2rem;
      color: #999999 !important;
    }
  }
  div.wae-section-margin-moderate {
    font-size: 1.4rem;
    color: #555;
  }
  .wae-section-note p {
    font-size: 1.2rem;
    color: #999!important;
  }
  table {
    border-collapse:collapse;
    td {
      padding: 2px 6px;
    }
  }

  ul:not(.wae-section-list-number) {
    padding-left: 24px;
    margin: 32px 0;
    li {
      color: #555555;
      font-size: 1.4rem;
      position: relative;
    }
    li:before {
      content: "";
      display: block;
      width: 4px;
      height: 4px;
      background-color: #555;
      border-radius: 2px;
      position: absolute;
      top: 6px;
      left: -20px;
    }
  }

  ul.wae-section-list-number {
    padding-left: 24px;
    margin: 32px 0;
    counter-reset: number;
    list-style: none;
    li {
      color: #555555;
      font-size: 1.4rem;
      position: relative;
    }
    li:before {
      counter-increment: number;
      content: "("counter(number)")";
      position: absolute;
      top: 0px;
      left: -26px;
      color: #555555;
      font-size: 1.4rem;
    }
  }
  img {
    margin: 32px 0;
    display: block;
    margin: 0 auto;
    width: 100%;
  }
  a {
    color: #005bac!important;
  }
  hr {
    border-top: 0;
    border-bottom: 1px solid #DDDDDD;
    margin: 10px 0;
  }
  .author {
    font-weight: bold;
    margin-bottom: 32px;
    p {
      margin: 0;
      line-height: 2;
    }
    &.author-default {
      text-align: right;
    }
    &.author-biz-lawyers {
      margin-left: 3rem;
    }
  }
  .box-gray,
  .box-gray-head,
  .box-gray-point {
    margin: 24px 0;
    padding: 20px;
    background-color: #DDDDDD;
    .label {
      position: relative;
      padding-left: 16px;
      font-size: 16px;
      letter-spacing: 0.05em;
      font-weight: bold;

      &::before {
        content: "";
        display: block;
        width: 8px;
        height: 100%;
        background-color: #036CCB;
        position: absolute;
        left: 0;
        top: 0;
      }
      & + * {
        margin-top: 32px;
      }
    }
    .date {
      margin-top: 0;
      text-align: right;
      & + * {
        margin-top: 16px;
      }
    }
    & > *:nth-child(1) {
      margin-top: 0;
    }
    p {
      margin: 16px 0;
      a {
        display: inline !important;
      }
    }
    img {
      max-width: 100%;
      margin: 16px 0;
    }
    ul {
      margin: 16px 0;
      li {
        & + li {
          margin-top: 8px;
        }
      }
    }
    a {
      text-decoration: underline;
      & + & {
        margin-top: 8px;
      }
    }
    dl {
      display: flex;
      align-items: flex-start;
      margin: 0;
      dt {
        width: 72px;
        line-height: 2;
        & > *:nth-child(1) {
          margin-top: 0;
        }
      }
      dd {
        width: calc(100% - 72px);
        & > *:nth-child(1) {
          margin-top: 0;
        }
        p {
          color: #005bac !important;
          font-size: 1.6rem;
        }
        a {
          font-size: 1.6rem;
        }
        a + a {
          margin-top: 0;
        }
      }
    }
  }
  .box-gray-head {
    margin-bottom: 0;
    padding-top: 8px;
    padding-bottom: 16px;
    .date {
      margin-top: 0;
      margin-bottom: 0;
    }
    & + .box-gray {
      margin-top: 0;
      padding-top: 0;
    }
  }
  .box-gray-point {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: flex-end;

    &::before {
      content: "POINT";
      display: inline-block;
      width: 64px;
      text-align: center;
      background-color: #CF131C;
      color: #fff;
      margin-right: 8px;
      padding: 2px 4px;
      letter-spacing: 0.05em;
      font-size: 1.4rem;
    }

    > * {
      width: calc(100% - 72px);
    }
  }
  .wae-section-list-number.box-gray,
  .wae-section-list-icon.box-gray,
  ul.box-gray {
    padding-left: 44px;
  }
  .wae-section-center {
    text-align: center;
  }
  .wae-section-right {
    text-align: right;
  }
  
  #shares-lab-footer-data {
    display: none;
  }
  .shares-lab-footer {
    a {
      display: inline-block;
      margin: 0;
    }
    #shares-lab-output {
      display: none;
    }
    #shares-lab-output-writer-area {
      border: #005bac solid 3px;
      padding: 10px;
      margin: 16px 0;
      a {
        display: inline-block;
      }
      p {
        margin: 0;
      }
    }
    .shares-lab-explanation {
      font-size: 90%;
      margin-bottom: 24px;
    }
    .box-logo {
      text-align: center;
      p {
        font-weight: bold;
        font-size: 16px;
        &.upper {
          margin-top: 0;
          margin-bottom: 8px;
        }
        &.lower {
          margin-top: 8px;
          margin-bottom: 0;
        }
      }
      figure {
        img {
          max-width: 100%;
          width: 270px;
          margin: 0 auto;
        }
      }
    }
  }
  #business-lawyers-footer-html,
  #business-lawyers-output-footer-html {
    display: none;
  }
  .business-lawyers-footer {
    .txt {
      font-size: 90%;
      margin-bottom: 16px;
      &-accent {
        color: #005bac;
        strong {
          font-weight: bold;
        }
      }
    }
    .box-logo {
      border: #005bac solid 3px;
      padding: 10px;
      margin: 24px 0 0;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: flex-start;
      .txt {
        width: 70%;
        margin: 0;
      }
      figure {
        width: 25%;
        margin: 0;
        img {
          margin: 3px 0 0;
        }
      }
      .txt-note {
        margin: 0 0;
      }
    }
  }
}




.navi-func-icon {
  position: absolute;
  right: 20px;
  top: 30px;
  z-index: 10;
  .icon {
    color: $color-link;
    white-space: nowrap;
    margin-right: 10px;
    background-color: #fff;
    display: inline;
    padding: 5px;
    border-radius: 4px;
    border: 0;
    position: relative;
    .tip {
      position: absolute;
      top: -20px;
      left: 50%;
      transform: translate3d(-50%,0,0);
      font-size: 1.4rem;
      font-weight: normal;
      white-space: nowrap;
      opacity: 0;
      transition: opacity .2s;
    }
    &:hover {
      box-shadow: 0 5px 20px rgba(0,0,0,.16);
      .tip {
        opacity: 1;
      }
    }
  }
}

</style>
